import { render, staticRenderFns } from "./tcpl3.vue?vue&type=template&id=3929576e&"
import script from "./tcpl3.vue?vue&type=script&lang=js&"
export * from "./tcpl3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports